function initMixedProducts() {
  document.querySelectorAll('[data-tx-config][data-mixed-order]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const product = JSON.parse(root.querySelector('[data-product]').textContent);
    const supplier = JSON.parse(root.querySelector('[data-supplier]').textContent || 'null');
    const t = JSON.parse(root.querySelector('[data-labels]').textContent);
    const form = root.querySelector('form'), color = root.querySelector('[data-color]');
    const grid = root.querySelector('[data-sizes]'), button = root.querySelector('[data-buy]');
    const status = root.querySelector('[data-status]'), gift = root.querySelector('[data-gift]');
    const stock = new Map((supplier?.variants || []).map(v => [v.sku, Number(v.stock)]));
    let selected = [], busy = false;
    const fresh = () => supplier && Date.now() - Date.parse(supplier.checked_at) < 86400000;
    const count = () => selected.reduce((sum, s) => sum + Number(s.input.value || 0), 0);
    const giftValid = () => !gift?.checked || (gift.dataset.id && Date.now() - Date.parse(gift.dataset.checkedAt) < 86400000 && Number(gift.dataset.stock) >= count());
    function money(el, net) {
      el.dataset.pmNetOre = String(net); el.dataset.currency = 'SEK';
      el.textContent = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(net / 100);
    }
    function summary() {
      const n = count(), amount = selected.reduce((sum, s) => sum + s.variant.price * Number(s.input.value || 0), 0);
      money(root.querySelector('[data-total]'), amount);
      const unit = root.querySelector('[data-unit-price]');
      if (unit) { money(unit, n ? Math.round(amount / n) : 0); unit.closest('p').hidden = !n; }
      root.querySelector('[data-count]').textContent = String(n);
      const guide = root.querySelector('[data-price-note]');
      button.textContent = n === 1 ? t.single_buy : t.buy;
      if (guide) guide.textContent = n === 1 ? t.selection_one + ' ' + t.single_note : n ? (n === 1 ? t.selection_one : t.selection_many.replace('{count}', String(n))) + ' ' + (n < 10 ? t.small_order : t.large_order) : '';
      root.querySelector('[data-stock-note]').textContent = fresh() ? t.stock : t.stale;
      if (gift) root.querySelector('[data-gift-note]').textContent = giftValid() ? '' : 'Knäskydd kan inte läggas med för valt antal just nu.';
      button.disabled = busy || n < 1 || !fresh() || !giftValid() || selected.some(s => !s.input.checkValidity() || Number(s.input.value) > (stock.get(s.variant.sku) || 0));
      window.PMVat?.render();
    }
    function rebuild() {
      grid.replaceChildren(); selected = [];
      for (const variant of product.variants.filter(v => v.option1 === color.value)) {
        const label = document.createElement('label'), name = document.createElement('span'), input = document.createElement('input');
        name.textContent = variant.option2 || variant.title;
        input.type = 'number'; input.min = '0'; input.step = '1'; input.inputMode = 'numeric'; input.placeholder = '0'; input.value = '';
        input.max = String(Math.max(0, stock.get(variant.sku) || 0));
        input.disabled = !fresh() || !variant.available || Number(input.max) < 1;
        input.setAttribute('aria-label', name.textContent + ' ' + color.value);
        label.append(name, input); grid.append(label); selected.push({ variant, input });
      }
      const variant = selected[0]?.variant, photo = root.querySelector('[data-photo]');
      photo.src = variant?.featured_image?.src || product.featured_image;
      photo.alt = product.title + ' ' + color.value; summary();
    }
    for (const value of new Set(product.variants.map(v => v.option1))) color.add(new Option(value, value));
    color.addEventListener('change', rebuild); form.addEventListener('input', summary); form.addEventListener('change', summary);
    form.addEventListener('submit', async event => {
      event.preventDefault(); summary(); if (button.disabled) return;
      busy = true; summary(); status.textContent = t.adding;
      const base = window.Shopify?.routes?.root || '/';
      const eligible = !/accessoar|accessor|keps|möss|cap|beanie/i.test(product.type || '');
      const items = selected.filter(s => Number(s.input.value) > 0).map(s => ({
        id: s.variant.id, quantity: Number(s.input.value), properties: {
          '_pm_line_id': crypto.randomUUID(), '_pm_garment': eligible ? '1' : '0',
          '_pm_no_center': /piké|pique|zip|cardigan|jacket|jacka|softshell/i.test(product.type + ' ' + product.title) || /^[FW]J/.test(supplier?.code || '') ? '1' : '0',
          '_pm_pants': /byxor|pants|shorts/i.test(product.type + ' ' + product.title) ? '1' : '0',
          'Modell': product.title, 'Färg': color.value, 'Storlek': s.variant.option2 || s.variant.title
        }
      }));
      if (gift?.checked) items.push({ id: gift.dataset.id, quantity: count(), properties: { 'Kampanj': 'AK02 på köpet med FP58' } });
      const addedQuantity = count();
      try {
        const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json(); if (!response.ok) throw Error(result.description || t.error);
        selected.forEach(s => { s.input.value = ''; });
        status.textContent = '';
        const added = root.querySelector('[data-added]');
        const addedText = added.querySelector('p');
        if (addedText) addedText.textContent = (addedQuantity === 1 ? t.selection_one : t.selection_many.replace('{count}', String(addedQuantity))) + ' ' + (addedQuantity === 1 ? t.single_added : t.added);
        const cartLink = added.querySelector('a');
        if (cartLink) { cartLink.textContent = addedQuantity === 1 ? t.single_cart_link : t.cart_link; cartLink.href = base + 'cart' + (addedQuantity === 1 ? '#pm-order-quote' : ''); }
        added.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) { status.textContent = error.message || t.error; }
      busy = false; summary();
    });
    const requested = product.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant'));
    color.value = requested?.option1 || (Array.from(color.options).some(o => o.value === 'Black') ? 'Black' : color.options[0]?.value);
    rebuild();
    fetch(root.dataset.pairsUrl).then(r => { if (!r.ok) throw Error(); return r.json(); }).then(pairs => {
      const pair = pairs[product.handle.replace(/^texstar-/, '')]; if (!pair) return;
      const container = root.querySelector('[data-pair-link]'), link = document.createElement('a');
      link.href = basePath() + 'products/' + pair.handle; link.textContent = pair.label === 'Dam' ? 'Se dammodellen' : 'Se herrmodellen';
      container.replaceChildren(link); container.hidden = false;
    }).catch(() => {});
    function basePath() { return window.Shopify?.routes?.root || '/'; }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMixedProducts); else initMixedProducts();
document.addEventListener('shopify:section:load', initMixedProducts);
